export default __webpack_public_path__ + "static/car-piece-2-60ef3ce24e8348f05ca3a39f20488d5d.jpg";